import axios from "axios";
import { httpClient } from "./http-client";
import { Parameter, ParameterValue } from "../common/types/parameters";
import { ModuleInfo } from "../common/types/modules";

let latestScheduledCalculationAbortController: AbortController | undefined;

export type CalculationAbortedResult = undefined;
export type ModuleCalculationResult = Parameter[] | CalculationAbortedResult;

export const scheduleUpcomingCalculation = (): AbortController => {
  latestScheduledCalculationAbortController?.abort();
  const calculationAbortController = new AbortController();
  latestScheduledCalculationAbortController = calculationAbortController;
  return calculationAbortController;
};

export const isCalculationAborted = (
  calculationAbortController: AbortController
): boolean => calculationAbortController.signal.aborted;

export const getModules = async (
  customer: string | undefined,
  economicProfile: string | undefined
): Promise<ModuleInfo[]> => {
  const response = await httpClient.get(
    `customers/${customer}/modules/economic-profile/${economicProfile}`
  );
  return response.data;
};

export const calculateOutput = async (
  module: string,
  input: ParameterValue[],
  customer: string | undefined,
  economicProfile: string | undefined
): Promise<ModuleCalculationResult> => {
  const calculationAbortController = latestScheduledCalculationAbortController;

  if (!calculationAbortController) {
    throw new Error(
      "A calculation must be scheduled before initiating a module calculation. Make sure to call scheduleUpcomingCalculation first."
    );
  }

  try {
    const response = await httpClient.post(
      `customers/${customer}/modules/${module}/economic-profile/${economicProfile}/results`,
      input,
      { signal: calculationAbortController.signal }
    );
    return !isCalculationAborted(calculationAbortController)
      ? response.data
      : (undefined as CalculationAbortedResult); // in case BE module calculation completed before processing the cancellation request
  } catch (error) {
    if (axios.isCancel(error)) {
      return undefined as CalculationAbortedResult;
    }

    throw error;
  }
};
